import { useQuery } from '@apollo/client';

import { MostVisitedCompaniesOrder } from '@xing-com/crate-common-graphql-types';

import { XcpMostVisitedCompaniesDocument } from '../../graphql/queries/most-visited-companies.gql-types';

export const ORDERS = {
  RANDOM: MostVisitedCompaniesOrder.Random,
  VISITS_COUNT_DESC: MostVisitedCompaniesOrder.VisitsCountDesc,
};

type MostVisitedCompaniesProps = {
  limit: number;
  offset?: number;
};

const useMostVisitedCompanies = ({
  limit = 4,
  offset = 0,
}: MostVisitedCompaniesProps) => {
  const variables = {
    limit,
    offset,
    order: ORDERS.RANDOM,
  };
  const { error, ...rest } = useQuery(XcpMostVisitedCompaniesDocument, {
    variables,
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: true,
  });

  return {
    error,
    ...rest,
  };
};

export { useMostVisitedCompanies };
